/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import { Container } from '../../styles/GlobalStyles'
import { FromCard } from './styles'
import { toast } from 'react-toastify'
import EyesOpen from '../../assets/icons/Eye.png'
import EyesClose from '../../assets/icons/EyeSlash.png'
import { version } from '../../db/data'
import ModalDownload from '../../components/Modals/ModalDownload'
import api from '../../services/axios'
import { Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

function Login() {
  const [nickname, setNickname] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [open, setOpen] = useState(false)
  const [currentVer, currentDate] = version.split('_')
  const { signIn } = useAuth()

  const [loading, setLoading] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [errorMessage, setErrorMessage] = useState('')

  async function handleSingIn() {
    setErrorMessage('')
    setLoading(true)

    if (!nickname || !password) {
      toast.error('Preencha todos os campos.')
      setLoading(false)
      return
    }

    try {
      const response = await api.post('/login', {
        nickname,
        password,
      })

      // O token não é guardado aqui de propósito: ele vem num cookie
      // HTTP-Only que o navegador administra sozinho. A resposta ainda traz
      // o campo `token` porque o integrador (que não é navegador) depende
      // dele — para esta tela, é para ser ignorado.
      if (response.data.user) {
        signIn(response.data.user)
      }

      toast.success('Login realizado com sucesso!')

      window.location.replace('/dashboard')
    } catch (err: any) {
      setLoading(false)
      toast.error(err.response?.data?.message || 'Erro ao fazer login. Tente novamente.')
    }
  }
  return (
    <>
      <Container>
        <FromCard action={() => handleSingIn()}>
          <div className='header'></div>

          <div className='left'>
            <div className='left-header'>
              <p>Login</p>
            </div>
            <div className='user'>
              <p>Usuário:</p>
              <input
                type='text'
                required
                placeholder='Digite seu usuário'
                onChange={(e) => setNickname(e.target.value)}
                value={nickname}
              />
            </div>
            <div className='user'>
              <p>Senha:</p>

              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <input
                  required
                  type={showPassword ? 'text' : 'password'}
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  placeholder='Digite sua senha'
                />

                <button
                  style={{
                    position: 'absolute',
                    right: 0,
                    width: 40,
                    height: 40,
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                  type='button'
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <img
                    style={{ width: 24 }}
                    src={showPassword ? EyesOpen : EyesClose}
                    alt='Mostrar senha'
                  />
                </button>
              </div>
            </div>

            {loading === true ? (
              <div className='loading-login'>
                <p className='btn-text'>Carregando...</p>
              </div>
            ) : (
              <button type='submit'>
                <p className='btn-text'>Entrar</p>
              </button>
            )}
            <Link style={{ color: '#fff', marginTop: 20 }} to='/termos-de-uso'>
              Termos de uso
            </Link>

            <div className='logo-footer'>
              <button
                style={{ background: 'transparent', display: 'flex', justifyContent: 'end' }}
                type='button'
                className='logo-footer'
                onClick={() => setOpen(!open)}
              >
                <span className='version'>{currentVer}</span>
                <span className='date'>({currentDate})</span>
              </button>
            </div>
          </div>
        </FromCard>
      </Container>

      {open && <ModalDownload closeModal={() => setOpen(!open)} />}
    </>
  )
}

export default Login
